module.exports = __webpack_public_path__ + "static/secondMovementBeginningArranged-f4b7eae1826cd7341ee603f034c2dd52.mp3";